import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CardRow from '../../../../components/CardRow/CardRow';
import CardRowCard from '../../../../components/CardRow/CardRowCard';
import { commodities } from '../../../../constants/commodities';
import PublicPriceDevelopment from './PublicPriceDevelopment';

const StyledCardRowCard = styled(CardRowCard)`
  box-shadow: 0 12px 17px 2px rgba(0,0,0,.07),0 5px 22px 4px rgba(0,0,0,.06),0 7px 8px -4px rgba(0,0,0,.1);
`;

const COMMODITIES = [commodities.ELE, commodities.GAS_CZVTP, commodities.GAS_THE];

const ProductPrices = () => {
  const [currency, setCurrency] = useState('EUR');

  const changeCurrency = (newCurrency) => {
    localStorage.setItem('currencyForGraph', newCurrency);
    setCurrency(newCurrency);
  };

  useEffect(() => {
    const savedCurrency = localStorage.getItem('currencyForGraph');

    if (savedCurrency != null && savedCurrency !== currency) {
      setCurrency(savedCurrency);
    }
  }, [currency]);

  return (
    COMMODITIES.map((commodity, index) =>
      <CardRow key={index}>
        <StyledCardRowCard key={index}>
          <PublicPriceDevelopment
            key={index}
            type={commodity.key}
            years={commodity.years}
            currency={currency}
            changeCurrency={changeCurrency}
          />
        </StyledCardRowCard>
      </CardRow>)
  );
};

ProductPrices.propTypes = {
  customerId: PropTypes.number,
};

export default ProductPrices;
